module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7MQHA"))).then(() => module.bundle.root('ewmtE'));